export function getDistanceUnit(state) {
  return state.DistanceUnit;
}
